import React, { useEffect } from "react";
import { StepRenderProps } from "../../../interfaces/FlowInterfaces";
import { TermsOfServiceStepValues } from "../../_interfaces/IAdminInvitationStepTypeValues";
import { IAdminInvitationFlowValues } from "../../_interfaces/IAdminInvitationFlowValues";
import { Container, createStyles, makeStyles, Paper, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { AdminInvitationHeader } from "../AdminInvitationHeader";
import { useTermsOfServiceController } from "../../hooks/useTermsOfServiceController";
import { TermsOfServiceForm } from "../../../../authentication/components/TermsOfServiceForm";
import { useRootStore } from "../../../../../shared/general/hooks";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            marginTop: theme.spacing(2),
            padding: theme.spacing(4),
            display: 'inline-block',
            position: 'relative' // the loading spinner refers to this element
        },
        termsOfService: {
            color: theme.palette.text.secondary,
        }
    })
);

export const TermsOfServiceStep: React.FC<
    StepRenderProps<TermsOfServiceStepValues, IAdminInvitationFlowValues>
> = observer(({
    values,
    update,
    submit,
    canSubmit,
    validation,
    allValues
}) => {

    /********* React hooks *********/

    const rootStore = useRootStore();
    const classes = useStyles();
    const controller = useTermsOfServiceController(values, allValues, update, submit);

    /********* Effects *********/

    useEffect(() => {
        update({
            termsOfServiceAccepted: false,
            userId: rootStore.userStore.user.id
        });
    }, [])

    /********* Render *********/

    return (
        <Container>
            <Paper className={classes.content}>
                <AdminInvitationHeader
                    organizationName={allValues.organizationName || ""}
                    hideDivider
                />
                <TermsOfServiceForm
                    values={controller.values}
                    onChange={(patch) => {
                        controller.onChange(patch);
                        update(patch); // sync with Flow
                    }}
                    onSubmit={controller.onSubmit}
                    isSubmitting={controller.isSubmitting}
                    error={controller.error}
                    fieldErrors={controller.fieldErrors}
                />
            </Paper>
        </Container>
    );
});
